<body class="ltr main-body leftmenu">
    <form>
        <!-- Main Content-->
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <!-- Page Header -->
                    <div class="page-header">
                        <div>
                            <h2 class="main-content-title tx-18 mg-b-5">All Users Records</h2>
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><a>Users Data</a></li>
                                <li class="breadcrumb-item active" aria-current="page">Add Users</li>
                            </ol>
                        </div>
                        <div class="d-flex">
                            <div class="justify-content-center">
                                <button type="button" class="btn btn-primary my-2 btn-icon-text floatright"
                                    (click)="addnewrecord('true')">
                                    Add New Record
                                </button>
                                <button type="button"
                                    class="btn btn-primary my-2 me-2  btn-icon-text floatright btn-default btn-lg">
                                    <i class="fe fe-download-cloud me-2"></i> Download Report
                                </button>
                                <button mat-button [matMenuTriggerFor]="menu" type="button"
                                    class="btn btn-white btn-icon-text my-2 me-2 dropdown-toggle floatright"
                                    data-toggle="dropdown">
    
                                    <i class="fe fe-filter me-2"></i> Doc Type
    
                                </button>
                                <mat-menu #menu="matMenu">
                                    <mat-option value="Yes">.csv </mat-option>
                                    <mat-option value="No">pdf</mat-option>
                                </mat-menu>
    
                                <!-- <button mat-button [matMenuTriggerFor]="menu">Menu</button>
                                      <mat-menu #menu="matMenu">
                                               <button mat-menu-item>Item 1</button>
                                     <button mat-menu-item>Item 2</button>
                                           </mat-menu> -->
    
                            </div>
                        </div>
                    </div>
                    <!-- End Page Header -->
    
                    <!-- Row -->
                    <!-- list of Users start  -->
                    <div class="row row-sm" *ngIf="list">
                        <div class="col-lg-12">
                            <div class="card custom-card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-7">
                                            <h3 class="main-content-label mb-1"><b>Users List</b></h3>
                                            <p class="text-muted card-sub-title mb-0">Users Data Information</p>
                                        </div>
                                        <!-- <div class="col-md-5" >
                                            <mat-form-field appearance="outline" class="example-full-width" >
                                                <mat-label>Search</mat-label>
                                                <input style="color:black;" matInput placeholder="Search">
                                                <mat-icon matSuffix>search</mat-icon>
                                            </mat-form-field>
                                        </div> -->
                                    </div>
    
    
    
                                    <div class="row form-data">
                                        <div class="col-lg-12">
                                            <div class="row align-items-center">
    
                                                <div class="col-md-1 my-2 my-md-0">
                                                    <!-- <div class="d-flex align-items-center">
                                                        <label class="mr-3 mb-0 mt-2 d-none d-md-block">Status:</label>
                                                        <div class="form-group">
                                                            <select name="country" class="form-control select-lg select2">
                                                                <option value="">Select</option>
                                                            </select>
                                                        </div>
                                                    </div> -->
                                                </div>
                                                <div class="col-md-1 my-2 my-md-0">
                                                    <!-- <div class="d-flex align-items-center">
                                                        <label class="mr-3 mb-0 mt-2 d-none d-md-block">Type:</label>
                                                        <div class="form-group">
                                                            <select name="country" class="form-control select-lg select2">
                                                                <option value="">Select</option>
                                                            </select>
                                                        </div>
                                                    </div> -->
                                                </div>
                                                <div class="col-lg-6 text-right">
                                                    <!-- <button type="button"
                                                        class="btn btn-primary my-2 btn-icon-text floatright"
                                                        (click)="addnewrecord('true')">
                                                        Add New Record
                                                    </button> -->
                                                    <!-- <button type="button"
                                                        class="btn btn-primary my-2 me-2  btn-icon-text floatright">
                                                        <i class="fe fe-download-cloud me-2"></i> Download Report
                                                    </button>
                                                    <button type="button"
                                                        class="btn btn-white btn-icon-text my-2 me-2 floatright">
                                                        <i class="fe fe-filter me-2"></i> Type
                                                    </button> -->
                                                </div>
    
                                            </div>
                                        </div>
                                    </div>
                                    <div class="table-responsive">
                                        <table id="datatable"
                                            class="table table-striped table-bordered text-nowrap text-left">
                                            <thead>
                                                <tr>
    
                                                    <th class="f600">
                                                        User
                                                    </th>
                                                    <th class="f600">
                                                        FullName
                                                    </th>
                                                    <th class="f600">
                                                        Level
                                                    </th>
                                                    <th class="f600">
                                                        Status
                                                    </th>
                                                    <!-- <th>Status</th>
                                                    <th>Type</th> -->
                                                    <th width="10%" class="f600 text-center">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody id="table_data" *ngIf="UsersList.length > 0">
                                                <tr *ngFor="let users of UsersList;">
    
                                                    <!-- <td> {{Users.User}} </td>
                                                    <td>{{Users.FullName}} </td>
                                                    <td>{{Users.Level}} </td>
                                                    <td>{{Users.Status}} </td> -->
                                                    <!-- <td><span class="label-light-primary">Cancelled </span></td>
                                                    <td class="text-success">• Direct</td> -->
                                                    <td class="text-center">
    
                                                        <a class="btn-floating" title="Edit"
                                                            (click)="editdata('true',Users)">
                                                            <i class="fa fa-edit"></i>
                                                        </a>
                                                        <a class="btn-floating" title="Delete" (click)="deletee('true',Users)">
                                                            <!-- <i class="fas fa-trash"></i> -->
                                                            <i class="fas fa-trash"></i>
                                                        </a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <!-- <div class="image" *ngIf="UsersList.length == 0">
                                                <img src="../../assets/images/students.png" class="imagenodata">
                                            </div> -->
                                        </table>
                                    </div>
    
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- list of Users end  -->
                    <!-- add of Users start  -->
                    <div class="row row-sm add-form" *ngIf="list == false ">
                        <form autocomplete="off" class="p-0" novalidate [formGroup]="UsersForm">
                            <div class="col-lg-12 col-md-12">
    
                                <div class="card custom-card">
                                    <div class="card-body">
                                        <div *ngIf="submitButton" class="mb-3">
                                            <h3 class="main-content-label mb-1"><b>Add New Users Record</b></h3>
                                            <p class="text-muted card-sub-title mb-0">Add New Users Information </p>
                                        </div>
                                        <div *ngIf="editButton" class="mb-3">
                                            <h3 class="main-content-label mb-1"><b>Update Users Record</b></h3>
                                            <p class="text-muted card-sub-title mb-0 ">Update Selected Users Information
                                            </p>
                                        </div>
                                        <div *ngIf="deleteButton" class="mb-3">
                                            <h3 class="main-content-label mb-1"><b>Delete Users Record</b></h3>
                                            <p class="text-muted card-sub-title mb-0 ">Delete Selected Users Information
                                            </p>
                                        </div>
                                        <div class="row clearfix">
                                            <div class="col-sm-6">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width" >
                                                            <mat-label>Login Name</mat-label>
                                                            <input [readonly]="isread" maxlength="5" [readonly]="isreaddelete" style="color:black;" matInput
                                                                placeholder="Login Name">
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width" >
                                                            <mat-label>Full Name</mat-label>
                                                            <input  [readonly]="isreaddelete" style="color:black;" matInput
                                                                placeholder="Full Name">
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width" >
                                                            <mat-label>Level</mat-label>
                                                            <input [readonly]="isread" maxlength="5" [readonly]="isreaddelete" style="color:black;" matInput
                                                                placeholder="Level">
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width" >
                                                            <mat-label>Status</mat-label>
                                                            <input  [readonly]="isreaddelete" style="color:black;" matInput
                                                                placeholder="Status">
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-12">
                                                <button type="submit"
                                                    class="btn btn-primary my-2 me-2 mt-0 btn-icon-text floatright btn-raised g-bg-blush2"
                                                    *ngIf="submitButton" (click)="submit()">Submit</button>
                                                <button type="submit"
                                                    class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                                                    *ngIf="editButton" (click)="update()">Update</button>
                                                <button type="submit"
                                                    class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                                                    *ngIf="deleteButton" (click)="openConformationModalBox()">Delete</button>
                                                <button type="submit"
                                                    class="mat-focus-indicator mat-menu-trigger btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                                    (click)="addnewrecord('false')">Back</button>
    
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <!-- list of Users end  -->
                </div>
            </div>
        </div>
    </form>
    </body>
    